import React from 'react';
import { ReactConversation } from '@indeed/messaging-react';

interface ConversationContainerProps {
    conversationId: string;
    isAutoResizeEnabled: boolean;
    additionalComposeActions?: React.ReactNode[];
    renderBeforeListComponents?: React.ReactNode[];
    navigationHandlers?: {
        onBackClick?: () => void;
        onNavigateToJobDetails?: () => void;
    };
}

const ConversationContainer: React.FC<ConversationContainerProps> = ({
    conversationId,
    isAutoResizeEnabled,
    additionalComposeActions,
    renderBeforeListComponents,
    navigationHandlers,
}) => {
    return (
        <ReactConversation
            conversationId={conversationId}
            isAutoResizeEnabled={isAutoResizeEnabled}
            additionalComposeActions={additionalComposeActions}
            renderBeforeListComponents={renderBeforeListComponents}
            navigationHandlers={navigationHandlers}
        />
    );
};

export default ConversationContainer;
